/**
 * Loading State Component
 * Reusable component for displaying loading states with animations
 */

import React from 'react';
import { LoadingAnimation } from './LoadingAnimation';
import { LottieAnimation } from './LottieAnimation';

interface LoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'spinner' | 'lottie';
  lottieData?: unknown;
  className?: string;
}

const sizeClasses = {
  sm: 'h-32',
  md: 'h-48',
  lg: 'h-64',
};

// const spinnerSizes = {
//   sm: 24,
//   md: 32,
//   lg: 48,
// };

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading...',
  size = 'md',
  variant = 'spinner',
  lottieData,
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center ${sizeClasses[size]} ${className}`}
    >
      {variant === 'lottie' && lottieData ? (
        <div className="w-24 h-24">
          <LottieAnimation animationData={lottieData} />
        </div>
      ) : (
        <LoadingAnimation message={message} />
      )}
    </div>
  );
};
